import React from 'react';
import './Form.css';

const FormSuccess = () => {
    return (
        <div className='form-content-right'>
            <h1 className='form-success'>Thanks for being awesome! We have received your request</h1>
            <img src="images/success-sky.png" alt= "success" className= "form-img-2"/>
            
        </div>
    )
}

export default FormSuccess;
